import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const navigate = useNavigate();

  const checkAuthentication = useCallback(() => {
    const accessToken = localStorage.getItem('access_token');
    const email = localStorage.getItem('email');

    return !!(accessToken && email);
  }, []);

  const requireAuth = useCallback(
    (callback) => {
      if (checkAuthentication()) {
        if (callback) callback();
        return true;
      } else {
        setShowLoginPopup(true);
        return false;
      }
    },
    [checkAuthentication]
  );

  const handleLoginPopupClose = useCallback(() => {
    setShowLoginPopup(false);
  }, []);

  const handleLoginSuccess = useCallback(
    (redirectPath) => {
      setShowLoginPopup(false);
      if (redirectPath) {
        navigate(redirectPath);
      }
    },
    [navigate]
  );

  const showLoginRequiredPopup = useCallback(() => {
    setShowLoginPopup(true);
  }, []);

  return {
    showLoginPopup,
    setShowLoginPopup,
    checkAuthentication,
    requireAuth,
    handleLoginPopupClose,
    handleLoginSuccess,
    showLoginRequiredPopup,
  };
};
